import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Layout from './components/Layout';
import Home from './pages/Home';
import About from './pages/About';
import Podcast from './pages/Podcast';
import Services from './pages/Services';
import ServiceDetail from './pages/ServiceDetail';
import Contact from './pages/Contact';

function App() {
  return (
    <HelmetProvider>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/om-mig" element={<About />} />
          <Route path="/podcast" element={<Podcast />} />
          <Route path="/ydelser" element={<Services />} />
          <Route path="/ydelser/:slug" element={<ServiceDetail />} />
          <Route path="/kontakt" element={<Contact />} />
        </Routes>
      </Layout>
    </HelmetProvider>
  );
}

export default App;
